import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import TitlesRoute from "./routes/projectManager/TitlesRoute";
import "./App.css";
import { Provider } from "react-redux";
import store from "./redux/store";
import PrivateRoute from "./routes/PrivateRoute";
import ProjectManagerRoute from "./routes/projectManager/ProjectManagerRoute";
import TitleRoute from "./routes/projectManager/TitleRoute";
import ProjectRoute from "./routes/projectManager/ProjectRoute";
import TranslationRoute from "./routes/TranslationRoute";
import TaskGlossariesRoute from "./routes/TaskGlossariesRoute";
import TaskMemoriesRoute from "./routes/TaskMemoriesRoute";
import GlossariesRoute from "./routes/projectManager/GlossariesRoute";
import ProjectsRoute from "./routes/projectManager/ProjectsRoute";
import GlossaryRoute from "./routes/projectManager/GlossaryRoute";
import MemoriesRoute from "./routes/projectManager/MemoriesRoute";
import MemoryRoute from "./routes/projectManager/MemoryRoute";
import AnalysisRoute from "./routes/projectManager/AnalysisRoute";
import AnalysesRoute from "./routes/projectManager/AnalysesRoute";
import UsersRoute from "./routes/projectManager/UsersRoute";
import ContractorRoute from "./routes/contractor/ContractorRoute";
import TasksRoute from "./routes/contractor/TasksRoute";
import TaskGlossaryRoute from "./routes/TaskGlossaryRoute";
import TaskMemoryRoute from "./routes/TaskMemoryRoute";
import TaskQARoute from "./routes/TaskQARoute";
import TaskTMdiffroute from "./routes/TaskTMdiff";

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter basename="/">
        <Switch>
          <Route exact path="/">
            <Redirect to="/PM/titles" />
          </Route>

          <Route exact path="/PM">
            <Redirect to="/PM/titles" />
          </Route>
          <Route exact path="/C">
            <Redirect to="/C/tasks" />
          </Route>

          <ProjectManagerRoute path="/PM/titles" component={TitlesRoute} />
          <ProjectManagerRoute path="/PM/projects" component={ProjectsRoute} />
          <ProjectManagerRoute path="/PM/users" component={UsersRoute} />
          <ProjectManagerRoute
            path="/PM/title/:titleID"
            component={TitleRoute}
          />
          <ProjectManagerRoute
            path="/PM/project/view/:projectID"
            component={ProjectRoute}
          />
          <ProjectManagerRoute
            path="/PM/memory/view/:memoryID"
            component={MemoryRoute}
          />
          <ProjectManagerRoute
            path="/PM/analysis/view/:analysisID"
            component={AnalysisRoute}
          />
          <ProjectManagerRoute
            path="/PM/glossary/view/:glossaryID"
            component={GlossaryRoute}
          />
          <ProjectManagerRoute path="/PM/analyses" component={AnalysesRoute} />
          <ProjectManagerRoute
            path="/PM/glossaries"
            component={GlossariesRoute}
          />
          <ProjectManagerRoute path="/PM/memories" component={MemoriesRoute} />
          <PrivateRoute
            path="/task/translate/:taskID"
            component={TranslationRoute}
          />
          <PrivateRoute
            path="/task/glossaries/:taskID"
            component={TaskGlossariesRoute}
          />
          <PrivateRoute
            path="/task/memories/:taskID"
            component={TaskMemoriesRoute}
          />
          <PrivateRoute
            path="/task/:taskID/glossary/:glossaryID"
            component={TaskGlossaryRoute}
          />
          <PrivateRoute
            path="/task/:taskID/memory/:memoryID"
            component={TaskMemoryRoute}
          />
          <PrivateRoute
            path="/task/quality/:taskID/:rowIDq"
            component={TaskQARoute}
          />
          <PrivateRoute
            path="/task/tmdiff/:rowID"
            component={TaskTMdiffroute}
          />

          <ContractorRoute path="/C/tasks" component={TasksRoute} />
        </Switch>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
